<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "InformasiBanner",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
